import { Injectable } from '@angular/core';
import { IRecetaData } from '@core/interfaces/entidades/receta.entidad';
import {
  ICrearRecetaReq,
  IDuplicarRecetaReq,
  IEditarRecetaReq,
} from '@core/interfaces/request-response/receta.dto.interface';
import { environment } from '@env/environment';
import { BaseHttpService } from '@shared/services/base-http.service';

@Injectable({
  providedIn: 'root',
})
export class RecetaApiService extends BaseHttpService {
  private baseUrl = `${environment.apiUrl}${environment.apiPreFix}/receta`;

  obtenerRecetas() {
    return this.withLoader(
      this.httpClient.get<IRecetaData[]>(this.baseUrl),
    );
  }

  obtenerRecetaPorId(id: number) {
    return this.withLoader(this.httpClient.get<IRecetaData>(`${this.baseUrl}/${id}`));
  }

  crear(req: ICrearRecetaReq) {
    return this.withLoader(this.httpClient.post<IRecetaData>(this.baseUrl, req));
  }

  editar(id: number, req: IEditarRecetaReq) {
    return this.withLoader(this.httpClient.put<IRecetaData>(`${this.baseUrl}/${id}`, req));
  }

  eliminar(id: number) {
    return this.withLoader(this.httpClient.delete(`${this.baseUrl}/${id}`));
  }

  duplicar(id: number, req: IDuplicarRecetaReq) {
    return this.withLoader(
      this.httpClient.post<IRecetaData>(`${this.baseUrl}/${id}/duplicar`, req),
    );
  }
}
